import { Plus, Search } from 'lucide-react';
import Button from '../ui/Button';

/** Create a Group and Find a Group, styled as in the going modal (GoingOptionsModal). Find shows only when there is a
 *  group to join (useJoinableEventGroups). */
export default function GroupChoiceButtons({
  canFindGroup,
  onCreateGroup,
  onFindGroup,
  className = '',
}) {
  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      <Button
        type="button"
        fullWidth
        variant="primary"
        onClick={onCreateGroup}
        leftIcon={<Plus className="h-4 w-4" />}
      >
        Create a Group
      </Button>
      {canFindGroup && (
        <Button
          type="button"
          fullWidth
          variant="secondary"
          onClick={onFindGroup}
          leftIcon={<Search className="h-4 w-4" />}
          className="border-primary text-purple-100 hover:bg-primary/20"
        >
          Find a Group
        </Button>
      )}
    </div>
  );
}
